/* eslint-disable no-unused-vars */
import React, { PropTypes } from 'react';
import Input from '../../form/Input';
import RaisedButton from 'material-ui/RaisedButton';
import { reduxForm } from 'redux-form';
import { validateRedux } from '../../../utilites/validate';
import FormContainer from '../../NonLoggedLayout/FormContainer';
import s from './../style';

const validate = data =>
  validateRedux(data, {
    username: {
      presence: {
        // message: '^Username is missing'
      },
      email: {
        message: '^Please enter valid e-mail'
      }
    },
    password: {
      presence: true
    }
  });

class LoginForm extends React.Component {
  static propTypes = {
    message: PropTypes.string,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  };

  onSubmit({ username, password }) {
    let { location } = this.props;
    let nextPathname = location.state ? location.state.nextPathname : '/fanbox';
    return Promise.resolve(this.props.login(username, password, nextPathname));
  }

  render() {
    const {
      fields: { username, password },
      handleSubmit,
      submitting,
      valid
    } = this.props;
    return (
      <FormContainer>
        <form noValidate onSubmit={handleSubmit(data => this.onSubmit(data))}>
          <div>
            <Input type="text" label="Username" required {...username} />
            <Input type="password" label="Password" required {...password} />
          </div>
          <div className={s.linkContent}>
            <RaisedButton
              label="Login"
              type="submit"
              secondary
              style={{ width: 255 }}
              disabled={submitting}
            />
          </div>
        </form>
      </FormContainer>
    );
  }
}

export default reduxForm({
  form: 'login',
  fields: ['username', 'password'],
  validate
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/auth/Login/index.jsx